/**
 * 微信工具类
 */
import Fetch from '@/apis/index'
import weixinApi from '@/apis/weixin'
import store from '@/store/index'
import Vue from 'vue'

const config = {
  jsApiList: ['getLocation']
}

/* 获取定位 */
export const getWeiXinLocation = () => {
  return new Promise((resolve, reject) => {
    WeiXinLoader().then((wx) => {
      wx.ready(() => {
        Vue.$vux.loading.show({ text: '定位中' })
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            Vue.$vux.loading.hide()
            resolve({ longitude: res.longitude, latitude: res.latitude })
          },
          fail: (error) => {
            console.error('微信定位失败', error)
            Vue.$vux.loading.hide()
            Vue.$vux.toast.show({ text: '定位失败', type: 'cancel' })
          }
        })
      })
    })
  })
}

/* 微信注册器 */
export const WeiXinRegister = () => {
  WeiXinLoader().then((wx) => {
    Fetch.request(weixinApi.getWeiXinAuth, { url: window.location.origin + window.location.pathname + window.location.search }).then((res) => {
      if (res.status === 200) {
        let { appId, nonceStr, signature, timestamp } = res.data
        // 微信配置
        wx && wx.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名
          jsApiList: config.jsApiList // 必填，需要使用的JS接口列表
        })
        // 微信错误监听
        wx.error((error) => {
          console.log('微信错误', res, error, store.getters.weixinConfig)
          Vue.$vux.loading.hide() // 隐藏定位loding
          if (error && error.errMsg.indexOf('require subscribe') !== -1) {
            Vue.$vux.alert.show({
              title: '未关注公众号',
              content: `${store.getters.weixinConfig.name}`
            })
          } else {
            Vue.$vux.alert.show({
              title: '微信签名异常',
              content: `${error.errMsg}`
            })
          }
        })
      }
    }).catch((error) => {
      console.log('获取微信配置异常', error)
      Vue.$vux.loading.hide() // 隐藏定位loding
    })
  })
}

/* 微信加载器 */
export const WeiXinLoader = () => {
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(window.wx)
    } else {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'http://res.wx.qq.com/open/js/jweixin-1.4.0.js'
      // script.src = 'http://res2.wx.qq.com/open/js/jweixin-1.4.0.js'
      script.onerror = reject
      script.onload = resolve(window.wx)
      document.head.appendChild(script)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/weixin.js